import { Calendar04Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Link } from "react-router-dom";
import { Show } from "shared/components";
import { cx } from "shared/utils";
import { formatCalendar } from "../helpers/format-calendar";
import { useMarkNotificationAsRead } from "../helpers/call-notification";
import { Notification, NotificationType } from "../types";

const LABELS: Partial<Record<NotificationType, string>> = {
  [NotificationType.ShowingReschedulePicked]: "New showing time picked",
  [NotificationType.ShowingRescheduleNoneWork]: "No offered times work",
  [NotificationType.ShowingRescheduleReminder]: "Reschedule pending"
};

const FALLBACK_TITLES: Partial<Record<NotificationType, string>> = {
  [NotificationType.ShowingReschedulePicked]:
    "The lead picked a new showing time",
  [NotificationType.ShowingRescheduleNoneWork]:
    "The lead said none of the offered times work",
  [NotificationType.ShowingRescheduleReminder]:
    "The lead hasn't picked a new showing time yet"
};

const showingDestination = (item: Notification): string => {
  if (item.url) return item.url;
  return item.metadata.showing_id
    ? `/showings?id=${item.metadata.showing_id}`
    : "/showings";
};

export const ShowingRescheduleNotificationCard = ({
  item
}: {
  item: Notification;
}) => {
  const { id, read_at, metadata, created_at, type } = item;
  const markAsRead = useMarkNotificationAsRead();

  const handleClick = () => {
    if (!read_at) markAsRead([id]);
  };

  const title =
    metadata.title?.trim() || FALLBACK_TITLES[type] || "Showing update";
  const body = metadata.body?.trim() ?? "";

  return (
    <Link
      to={showingDestination(item)}
      onClick={handleClick}
      className="block p-6 bg-background-1000 hover:bg-alpha-40 cursor-pointer space-y-3 w-full"
    >
      <div className="flex items-center justify-between gap-4">
        <span className="flex items-center gap-1.5 text-sm font-medium text-content-1000">
          <HugeiconsIcon
            icon={Calendar04Icon}
            size={16}
            className="text-primary-500"
            aria-hidden
          />
          {LABELS[type] ?? "Showing update"}
        </span>
        <p className="text-content-300 font-medium text-sm shrink-0">
          {formatCalendar(created_at)}
        </p>
      </div>
      <div className="flex items-start gap-4 min-w-0">
        <span
          className={cx(
            "mt-2 size-2.5 rounded-full shrink-0",
            read_at ? "bg-alpha-40" : "bg-primary-500"
          )}
        />
        <div className="min-w-0 space-y-1">
          <p className="text-lg font-bold text-content-1000">{title}</p>
          <Show if={Boolean(body)}>
            <p className="text-base text-content-400">{body}</p>
          </Show>
        </div>
      </div>
    </Link>
  );
};
